import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Container,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogTitle,
    List,
    ListItemText,
    ListItemButton,
    Divider,
} from "@mui/material";
import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { collection, getDocs, query, limit, orderBy, startAfter, where } from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import InfiniteScroll from "react-infinite-scroller";

import LockIcon from "@mui/icons-material/Lock";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function ScinarioList() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [user, setUser] = useState("");

    const [scinaData, setScinaData] = useState([]);

    const [hasMore, setHasMore] = useState(true);
    const [lastVisible, setLastVisible] = useState(null);

    const [filterUser, setFilterUser] = useState("all");

    // const isSP = useMediaQuery("(max-width:600px)");

    const handleChange = (event) => {
        setFilterUser(event.target.value);
    };

    const [failed, setFailed] = useState(false);

    const handleTransScina = (id, privacy, auther) => {
        if (privacy === false && auther !== user) {
            setFailed(true);
        } else {
            window.scrollTo(0, 0);
            navigate(`/scenario/${id}`);
        }
    };

    const handleFailedClose = () => {
        setFailed(false);
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                setUser(userLogin.uid);
                await fetchData();
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });
        return () => unsubscribe();
    }, []);

    const fetchData = async () => {
        const scinaRef = collection(db, "scinario");
        const userRef = collection(db, "member");

        try {
            const q = query(scinaRef, where("deleted", "==", false), orderBy("updateAt", "desc"), limit(10));
            const scinaSnap = await getDocs(q);

            if (scinaSnap.empty) {
                setHasMore(false);
                setLoading(false);
                return;
            }

            const scinas = [];
            scinaSnap.forEach((doc) => {
                const timestamp = doc.data().updateAt.seconds;
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

                scinas.push({
                    id: doc.data().id,
                    title: doc.data().title,
                    auther: doc.data().auther,
                    updateAt: formattedDate,
                    private: doc.data().private,
                    clear: doc.data().clear,
                });
            });

            const q2 = query(
                userRef,
                where(
                    "uid",
                    "in",
                    scinas.map((user) => user.auther)
                )
            );
            const inputSnap = await getDocs(q2);
            const updateScinas = scinas.map((scina) => {
                const matchingDoc = inputSnap.docs.find((doc) => doc.data().uid === scina.auther);
                if (matchingDoc) {
                    return {
                        ...scina,
                        name: matchingDoc.data().name,
                    };
                }
                return scina;
            });
            setScinaData(updateScinas);

            setLastVisible(scinaSnap.docs[scinaSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }

        setLoading(false);
    };

    const fetchMoreData = async () => {
        const userRef = collection(db, "member");
        const scinaRef = collection(db, "scinario");

        try {
            const q = query(scinaRef, where("deleted", "==", false), orderBy("updateAt", "desc"), limit(10), startAfter(lastVisible));
            const scinaSnap = await getDocs(q);

            if (scinaSnap.empty) {
                setHasMore(false);
                return;
            }

            const scinas = [];
            scinaSnap.forEach((doc) => {
                const timestamp = doc.data().updateAt.seconds;
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

                scinas.push({
                    id: doc.data().id,
                    title: doc.data().title,
                    auther: doc.data().auther,
                    updateAt: formattedDate,
                    private: doc.data().private,
                    clear: doc.data().clear,
                });
            });

            const q2 = query(
                userRef,
                where(
                    "uid",
                    "in",
                    scinas.map((user) => user.auther)
                )
            );

            const inputSnap = await getDocs(q2);
            const updateScinas = scinas.map((scina) => {
                const matchingDoc = inputSnap.docs.find((doc) => doc.data().uid === scina.auther);
                if (matchingDoc) {
                    return {
                        ...scina,
                        name: matchingDoc.data().name,
                    };
                }
                return scina;
            });
            setScinaData((prevData) => [...prevData, ...updateScinas]);

            setLastVisible(scinaSnap.docs[scinaSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }
    };

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Scinario List - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                <Box
                    sx={{ mt: 10 }}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <FormControl>
                        <InputLabel>作成者</InputLabel>
                        <Select value={filterUser} label="作成者" sx={{ minWidth: 358, maxWidth: 358 }} onChange={handleChange}>
                            <MenuItem value="all">すべて</MenuItem>
                            <MenuItem value="O73YrYlsmmWigCRGeq9aujj4Oxm1">かいむ</MenuItem>
                            <MenuItem value="1">キラリ</MenuItem>
                            <MenuItem value="2">09</MenuItem>
                            <MenuItem value="3">きくりん</MenuItem>
                            <MenuItem value="4">モロ星人</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <InfiniteScroll
                    pageStart={0}
                    loadMore={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        <Box
                            sx={{ m: 1 }}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                            key={0}
                        >
                            <CircularProgress />
                        </Box>
                    }
                >
                    <List sx={{ mt: 2 }}>
                        <Divider />
                        {scinaData
                            .filter((item) => {
                                if (filterUser === "all" || item.auther === filterUser) {
                                    return true;
                                } else {
                                    return false;
                                }
                            })
                            .map((item, i) => (
                                <ListItemButton key={i} divider onClick={() => handleTransScina(item.id, item.private, item.auther)}>
                                    <ListItemText
                                        primary={
                                            <Typography
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <span>{item.title}</span>
                                                <span>
                                                    {item.clear && <CheckCircleIcon />}
                                                    {item.private === false && <LockIcon />}
                                                </span>
                                            </Typography>
                                        }
                                        secondary={
                                            <Typography
                                                color="text.secondary"
                                                variant="body2"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <span style={{ color: "white" }}>{item.name}</span>
                                                <span>{item.updateAt}</span>
                                            </Typography>
                                        }
                                    />
                                </ListItemButton>
                            ))}
                    </List>
                </InfiniteScroll>
            </Container>

            <Dialog open={failed}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    非公開設定です
                </DialogTitle>
                <DialogActions sx={{ justifyContent: "center", display: "flex", mb: 2 }}>
                    <Button variant="contained" sx={{ width: "100px" }} onClick={handleFailedClose}>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ScinarioList;
